import React from 'react';
import { Col } from '@digital/ui';

import _ = require("lodash");
import './index.css';

interface InputLabelProps {
  label: string;
  span?: React.ComponentProps<typeof Col>['span'];
  children: React.ReactNode;
}

const InputLabel: React.FC<InputLabelProps> = ({ label, span, children }) => {
  return (
    <Col span={span}>
      <div className="float-label">
        {_.isEmpty(label)
          ? (<div style={{ marginTop: '24px' }}></div>)
          : (<label>{label}</label>)
        }

        <div className="container">{children}</div>
      </div>
    </Col>
  );
};

export default InputLabel;
